
export enum ActionType {
    REQUEST_NEXT_BATCH,
    RECEIVE_NEXT_BATCH,
    REQUEST_SETTINGS,
    RECEIVE_SETTINGS,
    SET_PAGE_ID
}

